import * as React from 'react';
import { useEffect, useMemo, useRef, useState } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import { Col, Label, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Concept } from '../../redux/ConceptSlice';
import { Node, selectUnitHierarchy } from '../../redux/EntitiesSlice';
import { isAdmin } from '../../redux/MiscSlice';
import { Network, selectDefinitionNetworks } from '../../redux/NetworkSlice';
import { getTaxonomyChanges, TaxonomyChangesState } from '../../redux/TaxonomyChangesSlice';
import { DtsConcept, getSelectedTaxonomyConcept, resetTaxonomyConceptState } from '../../redux/TaxonomyConceptSlice';
import { clearSelectedReference, loadAllTaxonomyReferences } from '../../redux/TaxonomyReferenceSlice';
import { ActiveTaxonomyVersionInfo, selectCurrentVersion } from '../../redux/TaxonomyVersionSlice';

interface MemberTableData {
    name: string;
    code: string;
    documentation: string;
}


export interface StyledSelectableListItem {
    label: string;
    value: string;
    disabled: boolean;
    checked: boolean;
    className: string;
    children: Array<StyledSelectableListItem>;
}

const ConceptBreakdownManager = () => {
    const dispatch = useAppDispatch();
    const isAdminUser: boolean = useAppSelector(isAdmin);
    var versionedConcept: DtsConcept | null = useAppSelector(getSelectedTaxonomyConcept);
    var changes: TaxonomyChangesState | null = useAppSelector(getTaxonomyChanges);
    var versionInfo: ActiveTaxonomyVersionInfo | null = useAppSelector(selectCurrentVersion);
    var unitHierarchy: Node | null = useAppSelector(selectUnitHierarchy);
    var definitionNetworks: Network[] = useAppSelector(selectDefinitionNetworks);

    var concept: Concept | null = versionedConcept ? versionedConcept.concept : null;
    const [versionYear, setVersionYear] = useState(versionInfo ? versionInfo.year : 2022);
    const memberTabulatorRef = useRef(null);


    const getNodeIcon = function (concept: Concept | null): string {
        if (!concept) {
            return "";
        }
        if (concept.code < "2") {
            return ""; // county
        }
        if (concept.code < "3") {
            return ""; // city
        }
        if (concept.code < "5") {
            return ""; // special district
        }
        if (concept.code < "9") {
            return ""; // other entity
        }
        return ""; // organizing node
    }
    const addNode = function (parent: StyledSelectableListItem | null, n: Node): StyledSelectableListItem {
        var nodeLabel = n.concept ? n.concept.name : n.name;
        var nvalue = n.concept ? n.concept.code : n.id;
        var listItem: StyledSelectableListItem = {
            label: nodeLabel,
            value: nvalue,
            disabled: false,
            checked: false,
            className: getNodeIcon(n.concept),
            children: []
        }
        if (parent) {
            parent.children.push(listItem);
        }
        if (n.outgoing) {
            n.outgoing.map(e => addNode(listItem, e.to));
        }
        return listItem;
    }
    const getAxisList = function (nlist: Network[]): StyledSelectableListItem[] {
        var alist: Array<StyledSelectableListItem> = [];
        if (nlist == null) {
            return [];
        }
        for (var net of nlist) {
            for (var root of net.roots) {
                if (root.concept.name === "Line items") {
                    continue;
                }
                var listItem: StyledSelectableListItem = {
                    className: "",
                    label: root.concept.name + " (" + net.name + ")",
                    value: net.name + "#" + root.concept.id,
                    disabled: false,
                    checked: false,
                    children: []
                }
                alist.push(listItem);
            }
        }
        alist.sort((a, b) => a.label.localeCompare(b.label));
        return alist;
    }
    const [axisList, setAxisList] = useState<StyledSelectableListItem[]>(getAxisList(definitionNetworks));


    const ddhandleUnitChange = function (currentNode: any, selectedNodes: any) {
    }

    const handleCellEdited = function (cell: any) {
    }

    // handle the logic to add a new account 
    const addMemberTitleFormatter = function (cell: any, formatterParams: any, onRendered: any) {

        //build dropdown
        var button = document.createElement("div");

        button.innerHTML = "<i class='bi bi-plus-circle' title='Add new Member...'></i>  Member";

        button.onclick = function () {
            // add code here

        }

        return button;
    }

    var newGridOptions = {};

    var defaultColumns = [
        //        { rowHandle: true, formatter: "handle", field: "buttonhandler", headerSort: false, width: 45, minWidth: 45, titleFormatter: addPartTitleFormatter },
        { title: "Member name", field: "name", width: 280, titleFormatter: addMemberTitleFormatter },
        { title: "Code", field: "code", width: 80, editor: "input" },
        { title: "Documentation", field: "documentation", editor: "textarea" }
    ];

    var tableData: MemberTableData[] = [
        { name: "Office Buildings", code: "01", documentation: "" },
        { name: "Residential Buildings", code: "02", documentation: "" },
        { name: "Retail Buildings", code: "03", documentation: "" },
        { name: "Multi-purpose Buildings", code: "13", documentation: "This includes multi-purpose skyscrapers, mall/office space, etc. " }
    ]

    useEffect(() => {
        dispatch(clearSelectedReference());
    }, [versionedConcept]);

    useEffect(() => {
        var crefList = changes ? changes.referenceChanges : [];
        //        console.log("use effect", changes ? changes.referenceChanges : null );
    }, [changes]);

    const secondElementStyle = {
        marginTop: '4pt',
        marginLeft: '1em'
    }
    const editButtonStyle = {
        marginTop: '4pt',
        marginLeft: '1em',
        marginBottom: '4pt'
    }
    const leftMarginStyle = {
        marginLeft: '1em'
    }
    const selRefStyle = {
        marginTop: '8pt',
        marginLeft: '1em'
    }
    const rightAlignStyle = {
        align: 'right'
    }
    const flexRow = {
        display: 'flex'
    }
    const flexRightChild = {
        marginLeft: 'auto',
        marginRight: '1em'
    }
    const axisSelectorOne = useMemo(() => {
        return (
            <DropdownTreeSelect
                id="breakdownPickerOne"
                data={axisList}
                keepTreeOnSearch={true} keepChildrenOnSearch={true}
                onChange={ddhandleUnitChange}
                texts={{ placeholder: "Choose Network..." }} />
        )
    }, [unitHierarchy, versionInfo]);
    const axisSelectorTwo = useMemo(() => {
        return (
            <DropdownTreeSelect
                id="breakdownPickerTwo"
                data={axisList}
                keepTreeOnSearch={true} keepChildrenOnSearch={true}
                onChange={ddhandleUnitChange}
                texts={{ placeholder: "Choose Network..." }} />
        )
    }, [unitHierarchy, versionInfo]);

    const axisSelectorThree = useMemo(() => {
        return (
            <DropdownTreeSelect
                id="breakdownPickerThree"
                data={axisList}
                keepTreeOnSearch={true} keepChildrenOnSearch={true}
                onChange={ddhandleUnitChange}
                texts={{ placeholder: "Choose Network..." }} />
        )
    }, [unitHierarchy, versionInfo]);

    const axisSelectorFour = useMemo(() => {
        return (
            <DropdownTreeSelect
                id="breakdownPickerFour"
                data={axisList}
                keepTreeOnSearch={true} keepChildrenOnSearch={true}
                onChange={ddhandleUnitChange}
                texts={{ placeholder: "Choose Network..." }} />
        )
    }, [unitHierarchy, versionInfo]);




    return (
        <React.Fragment>
            <Row>
                <Col sm="8">
                    <Row style={{ width: "100%" }}>
                        <Col className="text-md-right" >
                            <Label><b>Add breakdowns:</b></Label>
                        </Col>
                        <Col md="9" >
                            <Col md="9">
                                <h5 style={secondElementStyle}>
                                    {axisSelectorOne}
                                    {axisSelectorTwo}
                                    {axisSelectorThree}
                                    {axisSelectorFour}
                                </h5>
                            </Col>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    );
}
export default ConceptBreakdownManager;